module.exports = __webpack_public_path__ + "img/slide11.b2399856.png";